import { useState } from 'react';
import { faqs } from '@/mocks/bookData';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-4xl px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
          <i className="ri-question-line"></i>
          常见问题
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
          关于御宅书屋，你可能想了解
        </h2>
      </div>

      <div className="mt-10 space-y-3">
        {faqs.map((f, idx) => {
          const open = openIndex === idx;
          return (
            <div
              key={f.q}
              className={`rounded-xl border transition ${
                open ? 'border-primary-300 bg-primary-50/50' : 'border-background-200 bg-background-50'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : idx)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="flex items-center gap-3 font-heading text-sm font-bold text-foreground-950 md:text-base">
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${open ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'}`}>
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  {f.q}
                </span>
                <i className={`shrink-0 text-xl text-foreground-500 transition-transform ${open ? 'rotate-180' : ''} ri-arrow-down-s-line`}></i>
              </button>
              {open && (
                <div className="px-5 pb-5 pl-[3.75rem] text-sm leading-relaxed text-foreground-700">
                  {f.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}